<div class="flex items-center max-w-full h-28">
    <div
        class="bg-valamarbluesecondary/20 min-h-[7rem] p-2 min-w-[34rem] w-fit max-w-full my-2 overflow-auto border-black rounded-l-md flex items-center"
    >
        <div class="flex gap-2">
            @for (option of selectedOptions; track $index; let i = $index) {
            <div>
                <div class="flex justify-between gap-6 items-center m-1 py-2 px-4 bg-white rounded-sm">
                    <div class="flex flex-col w-max">
                        <div class="text-lg">{{ option.name }}</div>
                    </div>
                    <button
                        type="button"
                        (click)="deleteOptionOnClick(i)"
                        class="valben-icon-button valben-icon-button--compact"
                        [attr.aria-label]="'Ukloni ' + option.name">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="h-full">
        <div class="px-3 w-fit bg-valamarbluesecondary/20 flex h-full justify-center items-center rounded-r-md">
            <div
                (click)="newOptionOnClick()"
                class="px-8 py-2 border-2 border-valamarblueprimary bg-white rounded-md font-semibold hover:bg-valamarblueprimary hover:text-white cursor-pointer"
                [ngClass]="
                    showNewOptionButton && ((optionsFiltered$ | async) || []).length > 0 ? '' : 'pointer-events-none select-none bg-white/0 text-white/0 border-white/0'
                "
            >
                NOVO
            </div>
        </div>
    </div>
</div>
@if (showOptions) {
    <div class="my-2">
        <valben-searchable-select
            class="min-w-[34rem] w-fit max-w-full"
            [options]="selectOptions"
            [loading]="serverSide && pageLoading"
            [serverSide]="serverSide"
            [searchDebounce]="filterTime"
            [virtualScroll]="true"
            [virtualItemSize]="63"
            [value]="pickedId"
            (searchChange)="onSearch($event)"
            (scrolledToEnd)="onScrolledToEnd()"
            (valueChange)="add($event)" />
        <button
            type="button"
            (click)="cancelOnClick()"
            class="valben-icon-button mx-2"
            aria-label="Zatvori odabir">
            <mat-icon>close</mat-icon>
        </button>
    </div>
}
